export default __webpack_public_path__ + "static/media/ic-supp-direct-feed.99c10020.svg";